import React from 'react';
import { Crown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface UpgradePromptProps {
  feature: string;
  description: string;
  onUpgrade: () => void;
}

export function UpgradePrompt({ feature, description, onUpgrade }: UpgradePromptProps) {
  const navigate = useNavigate();

  return (
    <div className="text-center space-y-6">
      <div className="w-16 h-16 rounded-full bg-[var(--accent-color)] flex items-center justify-center mx-auto">
        <Crown className="w-8 h-8 text-black" />
      </div>
      <div>
        <h2 className="text-2xl font-bold mb-2">{feature}</h2>
        <p className="text-gray-400 max-w-md mx-auto">{description}</p>
      </div>
      <button
        onClick={() => navigate('/subscription')}
        className="px-6 py-3 bg-[var(--accent-color)] text-black rounded-xl font-medium hover:opacity-90 transition-opacity"
      >
        Upgrade to Premium
      </button>
    </div>
  );
}